import { Boundaries } from "@planzone/core";
import { Identifiable, Project } from "@planzone/dto";

function handleValidateTimeRecordsUpToDateRequest(
  project: Identifiable<Project>,
  req: Boundaries["validateTimeRecordsUpToDate"]["request"],
): Identifiable<Project> {
  return req.project.uuid === project.uuid
    ? { ...project, integratedAt: req.date }
    : project;
}

function handleValidateTimeRecordsUpToDateSuccess(
  project: Identifiable<Project>,
  req: Boundaries["validateTimeRecordsUpToDate"]["success"],
): Identifiable<Project> {
  return req.project.uuid === project.uuid
    ? { ...project, integratedAt: req.date }
    : project;
}

function handleValidateTimeRecordsUpToDateFailure(
  project: Identifiable<Project>,
  req: Boundaries["validateTimeRecordsUpToDate"]["failure"],
): Identifiable<Project> {
  return req.project.uuid === project.uuid
    ? { ...project, integratedAt: req.project.integratedAt }
    : project;
}

export {
  handleValidateTimeRecordsUpToDateRequest,
  handleValidateTimeRecordsUpToDateSuccess,
  handleValidateTimeRecordsUpToDateFailure,
};
